import { Component, input } from '@angular/core';
import { SharedModule } from '@app/modules/shared.module';
import { TransmissionProfessionnel } from '@app/models/carnet-liaison';
import { CarnetHeureFormatPipe } from '../../carnet-liaison.pipe';

@Component({
  selector: 'app-carnet-transmission-pro',
  templateUrl: './carnet-transmission-pro.component.html',
  styleUrl: './carnet-transmission-pro.component.scss',
  standalone: true,
  imports: [SharedModule, CarnetHeureFormatPipe],
})
export class CarnetTransmissionProComponent {
  data = input.required<TransmissionProfessionnel>();
}
